import http from '@/http';

export default {
    namespaced:true,
    state: {
        webData     : null,
        isMobile    : false,
    },
    actions:{
        getWebData({commit}){
            return http.get('appData').then(res => {
                commit('SET_WEB_DATA',res.payload);
                return Promise.resolve(res.payload);
            });
        },
        setIsMobile({commit},value){
            commit('SET_IS_MOBILE',value);
        },
    },
    mutations:{
        SET_IS_MOBILE(state,value){
            state.isMobile        = value;
        },
        SET_WEB_DATA(state,webData){
            state.webData         = webData;
        },
    },
    getters:{
        webData           : (state) => state.webData,
        isMobile          : (state) => state.isMobile
    }


}